import { DateTime } from 'luxon';

const generateRows = (users: CoreUser[]): TableRow[] =>
  users.map((user) => {
    const payload: TableRow = {
      id: user.id ?? '',
      locationId: user.locationId ?? '',
      name: user.name ?? '',
      email: user.email ?? '',
      phone: user.phone ?? '',
      type: user.type ?? '',
      role: user.role ?? '',
      createdAt: user.createdAt
        ? DateTime.fromISO(user.createdAt).toLocaleString(DateTime.DATETIME_MED)
        : '',
      updatedAt: user.updatedAt
        ? DateTime.fromISO(user.updatedAt).toLocaleString(DateTime.DATETIME_MED)
        : ''
    };
    return payload;
  });

export default generateRows;
